import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Besttaxiserviceinmumbai() {



const cardData = {
  keyword: " Best Taxi Service in Mumbai",

headingDescription:
  "Omshree Cab offers one of the best taxi services in Mumbai, providing reliable, comfortable, and affordable transportation for local travel, airport transfers, business trips, and outstation journeys. Whether you need a cab for daily commuting, sightseeing, corporate travel, or family outings, our service ensures a smooth and safe ride with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way rides, round-trip bookings, hourly rentals, and full-day packages at transparent pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and large groups. With professional chauffeurs who know Mumbai’s roads well, punctual pickups from any location in the city, and 24/7 customer support, Omshree Cab is your trusted choice for the best taxi service in Mumbai.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic tourist landmarks located near the Arabian Sea. Built during the British era, it attracts thousands of visitors every day who come to admire its architecture, take photographs, and enjoy ferry rides to Elephanta Island. Travelers often begin their Mumbai sightseeing from this famous monument. Booking a comfortable taxi makes it easy to reach the area without worrying about parking or heavy traffic in South Mumbai."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a beautiful seaside promenade stretching along the Arabian Sea and is popularly known as the Queen’s Necklace because of its sparkling night lights. Visitors love coming here for evening walks, sunset views, and relaxing by the sea. It is one of the most peaceful places in the busy city. A taxi service allows visitors to comfortably travel along the stretch and enjoy the scenic coastal drive."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of the most famous beaches in Mumbai and a favorite hangout spot for both locals and tourists. People visit here to enjoy street food like pav bhaji, bhel puri, and kulfi while watching the sunset. The beach is also popular for morning walks and evening relaxation. Traveling by cab provides convenient access from different parts of the city, especially during weekends when the area gets crowded."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is one of the most revered temples in Mumbai dedicated to Lord Ganesha. Devotees from across India visit this temple to seek blessings and participate in religious rituals. The temple becomes especially crowded during festivals like Ganesh Chaturthi. Using a reliable taxi service helps visitors reach the temple comfortably and avoid parking issues in the busy Prabhadevi area."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a lively shopping street famous for fashion items, jewelry, handicrafts, and souvenirs. It is a paradise for bargain shoppers and also home to many popular cafes and restaurants. Visitors enjoy exploring the vibrant street markets and experiencing Mumbai’s local culture. A taxi ride makes it easy to reach Colaba and explore nearby attractions like the Gateway of India and Kala Ghoda."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on a small island off the Mumbai coast. The white marble structure stands beautifully in the middle of the Arabian Sea and is connected to the mainland by a narrow walkway. Visitors from all religions come here to pray and experience the peaceful atmosphere. Taking a cab ensures easy travel to this popular spiritual destination."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves located on Elephanta Island and are recognized as a UNESCO World Heritage Site. The caves are famous for their magnificent sculptures of Lord Shiva and impressive stone carvings dating back centuries. Visitors take ferries from the Gateway of India to reach the island. Using a taxi service makes it easy to reach the ferry terminal and plan a smooth sightseeing trip."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is one of Mumbai’s most impressive engineering landmarks connecting Bandra and Worli across the Arabian Sea. The bridge offers stunning views of the coastline and city skyline, especially during sunset and nighttime. Many travelers enjoy driving across the bridge for the scenic experience. A taxi ride allows visitors to enjoy the view comfortably without worrying about navigating traffic."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description:
      "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a historic railway station and a UNESCO World Heritage Site known for its Victorian Gothic architecture. The station is an important transportation hub as well as a major tourist attraction. Visitors admire its intricate design, stained glass windows, and historic significance. A cab service ensures convenient access to this busy landmark."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped gardens located on Malabar Hill. The gardens offer panoramic views of Marine Drive and are known for their animal-shaped hedges and peaceful atmosphere. Visitors often come here for relaxation, photography, and sunset views. Traveling by taxi makes it easy to include this attraction along with other South Mumbai sightseeing spots."
  }
],




services: [
{
name: "Best Taxi Service in Mumbai",
description: "Best taxi service in Mumbai offers reliable and comfortable transportation for passengers traveling across the city and nearby destinations. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth travel through busy Mumbai roads. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, and airports. Ideal for business travelers, tourists, and daily commuters. Spacious interiors provide relaxed seating during city rides. Flexible booking options allow passengers to schedule rides anytime. Transparent pricing ensures no hidden charges for customers. Trusted service quality ensures a dependable travel experience across Mumbai."
},
{
name: "Best Cab Service Mumbai",
description: "Best cab service in Mumbai provides dependable transportation solutions for local travel, airport transfers, and outstation journeys. Our modern fleet of AC vehicles ensures comfortable travel for individuals, families, and corporate passengers. Professional drivers ensure punctual pickups and safe driving through city and highway routes. Pickup is available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism, corporate travel, and daily commuting needs. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow easy travel planning. Reliable cab services ensure a smooth and safe ride across Mumbai."
},
{
name: "Best Car Rental Service Mumbai",
description: "Best car rental service in Mumbai offers premium and budget-friendly vehicles for comfortable city and outstation travel. Our fleet includes sedans, SUVs, and luxury vehicles suitable for various travel requirements. Professional chauffeurs ensure safe driving and punctual arrival at destinations. Pickup services are available across Mumbai including homes, hotels, offices, and airports. Ideal for business trips, tourism travel, and family outings. Comfortable interiors ensure relaxed journeys for passengers. Flexible rental packages allow hourly, daily, or outstation bookings. Reliable service ensures smooth travel experiences in Mumbai."
},
{
name: "Top Taxi Service Mumbai",
description: "Top taxi service in Mumbai provides trusted transportation solutions for passengers seeking safe and comfortable travel. Our AC vehicles ensure smooth rides through busy city traffic and highways. Experienced drivers ensure punctual pickup and professional driving service. Pickup services are available across Mumbai including residential areas, offices, hotels, and airports. Ideal for business travelers, tourists, and local commuters. Spacious interiors provide comfortable seating during travel. Flexible ride scheduling allows convenient trip planning. Reliable taxi services ensure smooth and safe city transportation."
},
{
name: "Reliable Taxi Service Mumbai",
description: "Reliable taxi service in Mumbai offers dependable transportation for passengers traveling within the city or nearby destinations. Our fleet includes well-maintained AC vehicles designed for comfortable travel. Professional drivers ensure safe driving and punctual arrival at your destination. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for corporate travel, airport transfers, and tourism visits. Spacious seating ensures comfortable rides for passengers. Flexible booking options allow easy ride scheduling. Trusted taxi services ensure safe and reliable transportation."
},
{
name: "Professional Taxi Service Mumbai",
description: "Professional taxi service in Mumbai offers high-quality transportation solutions for business travelers and tourists. Our AC vehicles ensure comfortable travel across city routes and highways. Experienced drivers provide courteous service and safe driving practices. Pickup services are available across Mumbai including homes, offices, hotels, and airports. Ideal for corporate meetings, business travel, and tourism trips. Spacious interiors ensure relaxed seating during travel. Flexible booking options allow convenient scheduling. Reliable professional taxi services ensure smooth travel experiences."
},
{
name: "Affordable Taxi Service Mumbai",
description: "Affordable taxi service in Mumbai provides budget-friendly transportation for passengers seeking economical travel options. Our AC vehicles offer comfortable seating while maintaining affordable pricing. Professional drivers ensure safe driving and timely arrival at destinations. Pickup services are available across Mumbai including residential areas, offices, hotels, and airports. Ideal for students, daily commuters, and budget travelers. Clean interiors ensure comfortable rides throughout the journey. Flexible booking options allow convenient ride scheduling. Transparent fares ensure affordable and reliable taxi services."
},
{
name: "Best Airport Taxi Mumbai",
description: "Best airport taxi in Mumbai offers reliable pickup and drop services for travelers using Mumbai Airport terminals. Our AC vehicles ensure smooth travel between airport and city destinations. Professional drivers monitor flight schedules to ensure timely pickup and drop services. Pickup is available from Terminal 1 and Terminal 2 of Mumbai Airport. Ideal for business travelers, tourists, and family travel. Spacious seating ensures comfortable airport transfers. Flexible booking options allow easy ride scheduling. Reliable airport taxi services ensure stress-free travel."
},
{
name: "Best Outstation Cab Mumbai",
description: "Best outstation cab in Mumbai offers comfortable long-distance transportation for travelers planning trips outside the city. Our fleet includes sedans, SUVs, and luxury vehicles suitable for highway journeys. Professional drivers ensure safe driving and punctual arrival at the destination. Pickup services are available across Mumbai including homes, hotels, and airports. Ideal for weekend trips, family vacations, and pilgrimage tours. Spacious seating ensures comfort during long journeys. Flexible one-way and round-trip options allow convenient travel planning. Reliable outstation cab services ensure safe travel."
},
{
name: "Best Cab Company Mumbai",
description: "Best cab company in Mumbai provides trusted transportation services for passengers across the city. Our fleet includes modern AC vehicles designed for comfortable travel experiences. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for corporate travel, tourism visits, and personal trips. Spacious seating ensures comfortable rides for passengers. Flexible booking options allow easy ride scheduling. Reliable cab company services ensure dependable transportation."
},
{
name: "Trusted Taxi Service Mumbai",
description: "Trusted taxi service in Mumbai offers safe and dependable transportation for passengers traveling across the city. Our fleet includes clean AC vehicles suitable for comfortable travel. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including residential areas, hotels, offices, and airports. Ideal for families, tourists, and corporate travelers. Spacious interiors ensure comfortable seating during travel. Flexible booking options allow convenient ride scheduling. Trusted taxi services ensure reliable city transportation."
},
{
name: "Premium Taxi Service Mumbai",
description: "Premium taxi service in Mumbai offers executive-level transportation for passengers seeking superior comfort and style. Our fleet includes luxury sedans and premium SUVs designed for smooth travel. Professional chauffeurs ensure safe driving and courteous service. Pickup services are available across Mumbai including hotels, offices, and airports. Ideal for corporate executives, VIP guests, and special occasions. Spacious interiors ensure high comfort during journeys. Flexible booking options allow convenient ride scheduling. Premium taxi services ensure luxurious travel experiences."
},
{
name: "Luxury Cab Service Mumbai",
description: "Luxury cab service in Mumbai provides high-end transportation for travelers seeking premium travel comfort. Our luxury vehicles include executive sedans and SUVs with spacious interiors. Professional chauffeurs ensure smooth driving and professional service. Pickup services are available across Mumbai including hotels, offices, and airport terminals. Ideal for VIP travel, corporate meetings, and special events. Comfortable seating ensures relaxed journeys. Flexible booking options allow convenient scheduling. Luxury cab services ensure stylish and comfortable transportation."
},
{
name: "Best Taxi Booking Mumbai",
description: "Best taxi booking in Mumbai provides easy and quick ride reservations for passengers planning city travel. Online booking systems allow instant confirmation and convenient ride scheduling. Comfortable AC vehicles ensure smooth travel across Mumbai roads. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, and airports. Ideal for tourists, corporate travelers, and daily commuters. Flexible travel options allow convenient trip planning. Reliable taxi booking services ensure hassle-free transportation."
}
],

tableData: [
["Best Taxi Service in Mumbai","Best Cab Service Mumbai"],
["Best Car Rental Service Mumbai","Top Taxi Service Mumbai"],
["Reliable Taxi Service Mumbai","Professional Taxi Service Mumbai"],
["Affordable Taxi Service Mumbai","Best Airport Taxi Mumbai"],
["Best Outstation Cab Mumbai","Best Cab Company Mumbai"],
["Trusted Taxi Service Mumbai","Premium Taxi Service Mumbai"],
["Luxury Cab Service Mumbai","Best Taxi Booking Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Mumbai Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in navigating Mumbai’s busy roads, traffic conditions, and major routes. Whether you need a cab for city travel, airport transfers, or outstation journeys, our professional drivers ensure a safe and smooth ride."
  },
  {
    WhyChooseheading: "Transparent & Affordable Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and transparent pricing for the best taxi service in Mumbai. We explain per-kilometer fares, toll charges, and travel packages in advance so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Taxi Service",
    WhyChoosedescription: "Mumbai is a city that never sleeps, and our taxi service operates 24/7. Whether it’s an early morning airport drop, a late-night ride, or an urgent trip, Omshree Cabs is always ready to serve."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures comfortable travel for both local and outstation journeys."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer multiple travel options including local hourly packages, airport transfers, outstation taxi services, and corporate cab bookings to suit different travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for solo travelers, families, and corporate clients."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Our cab service provides convenient pickup from homes, offices, hotels, railway stations, and airports anywhere in Mumbai so your journey begins smoothly."
  },
  {
    WhyChooseheading: "Reliable & Professional Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable taxi services in Mumbai. Our punctual drivers, comfortable vehicles, and professional customer support ensure a stress-free travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide taxi service across Mumbai?", answer: "Yes, Omshree Cabs provides taxi services across all areas of Mumbai including South Mumbai, Western Suburbs, Eastern Suburbs, and Navi Mumbai." },
  { question: "Do you offer airport pickup and drop services?", answer: "Yes, we provide airport taxi services to and from Mumbai Airport terminals for convenient travel." },
  { question: "Can I book outstation cabs from Mumbai?", answer: "Yes, Omshree Cabs provides outstation taxi services from Mumbai to destinations like Pune, Lonavala, Nashik, Surat, and many other cities." },
  { question: "Which vehicles are available for booking?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your comfort preference and group size." },
  { question: "Is taxi service available 24 hours?", answer: "Yes, Omshree Cabs operates 24/7 for local city travel, airport transfers, and outstation trips." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide corporate taxi services?", answer: "Yes, we provide corporate cab services for business meetings, employee transportation, and airport transfers." },
  { question: "Can I book a taxi online?", answer: "Yes, customers can easily book a taxi online or via phone for quick confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak hours, weekends, and festival seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Mehta",
    feedback:
      "Omshree Cabs is truly one of the best taxi services in Mumbai. The driver arrived on time and the vehicle was very clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "I booked Omshree Cabs for airport transfer in Mumbai and the service was excellent. Smooth ride, transparent pricing, and professional driver.",
    rating: 5
  }
];





















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Taxi Service in Mumbai",
  "description": "Omshree Cab offers the best taxi service in Mumbai with professional, reliable, and affordable options. Book cabs for airport transfers, outstation trips, corporate travel, and luxury rides. Easy online booking and trusted taxi service across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5200"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Best Taxi Service in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides the best taxi service in Mumbai. Professional and reliable cabs for airport transfers, outstation trips, corporate and luxury travel. Affordable fares and easy online taxi booking in Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Besttaxiserviceinmumbai;